// src/oura/delivery/CreateFromDelivery.tsx
//
// "Create the doc" from a deliverable (H31, scope 2.18): lane 2's Create a
// doc sheet, inside Delivery's drawer, filled in with the deliverable's doc
// type, codes and outlet. The drawer's Back returns to the deliverable.
// The board (route 7) is read only while this sheet is open, for the
// contract's codes, the Word files and the next doc the plan wants. The new
// doc is never shared on create: the deliverable's step then reads "Read
// it, then share".

import { CreateDocSheet } from "../components/docs/create/CreateDocSheet";
import type { CreatePrefill } from "../components/docs/create/createModel";
import { useBusinessDocuments } from "@oura/docs";

export function CreateFromDelivery({
    businessId,
    businessName,
    prefill,
    onOpenDoc,
    onNext,
    onClose,
}: {
    businessId: string;
    businessName: string;
    prefill: CreatePrefill;
    /** The doc just made, or the one a refusal names, in the Client tab's drawer. */
    onOpenDoc: (docId: string) => void;
    onNext: (prefill: CreatePrefill) => void;
    /** Back to the deliverable. */
    onClose: () => void;
}) {
    const board = useBusinessDocuments(businessId);
    return (
        <CreateDocSheet
            businessId={businessId}
            businessName={businessName}
            board={board.data}
            prefill={prefill}
            onOpenDoc={onOpenDoc}
            onNext={onNext}
            onClose={onClose}
        />
    );
}
